export default __webpack_public_path__ + "static/media/team-4.47b23df4.jpg";